let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3fLE9")).then(() => parcelRequire('lqPAG'));